/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The OrmOrg model module.
 * @module model/OrmOrg
 * @version 1.0
 */
class OrmOrg {
    /**
     * Constructs a new <code>OrmOrg</code>.
     * @alias module:model/OrmOrg
     */
    constructor() { 
        
        OrmOrg.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>OrmOrg</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OrmOrg} obj Optional instance to populate.
     * @return {module:model/OrmOrg} The populated <code>OrmOrg</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OrmOrg();

            if (data.hasOwnProperty('abbv')) {
                obj['abbv'] = ApiClient.convertToType(data['abbv'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'String');
            }
            if (data.hasOwnProperty('defaultLangCode')) {
                obj['defaultLangCode'] = ApiClient.convertToType(data['defaultLangCode'], 'String');
            }
            if (data.hasOwnProperty('deletedAt')) {
                obj['deletedAt'] = ApiClient.convertToType(data['deletedAt'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('rowId')) {
                obj['rowId'] = ApiClient.convertToType(data['rowId'], 'Number');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} abbv
 */
OrmOrg.prototype['abbv'] = undefined;

/**
 * @member {String} createdAt
 */
OrmOrg.prototype['createdAt'] = undefined;

/**
 * @member {String} defaultLangCode
 */
OrmOrg.prototype['defaultLangCode'] = undefined;

/**
 * @member {String} deletedAt
 */
OrmOrg.prototype['deletedAt'] = undefined;

/**
 * @member {String} name
 */
OrmOrg.prototype['name'] = undefined;

/**
 * @member {Number} rowId
 */
OrmOrg.prototype['rowId'] = undefined;

/**
 * @member {String} updatedAt
 */
OrmOrg.prototype['updatedAt'] = undefined;






export default OrmOrg;

